/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchOperationResponseDto,
  BatchUpdateRequestsDto,
  DataSharingRequestsResponseDto,
  ErrorResponse,
  GetDataSharingRequestsDto,
  InitiateDataSharingResponseDto,
  RequestDetailDto,
} from '../models/index';
import {
    BatchOperationResponseDtoFromJSON,
    BatchOperationResponseDtoToJSON,
    BatchUpdateRequestsDtoFromJSON,
    BatchUpdateRequestsDtoToJSON,
    DataSharingRequestsResponseDtoFromJSON,
    DataSharingRequestsResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetDataSharingRequestsDtoFromJSON,
    GetDataSharingRequestsDtoToJSON,
    InitiateDataSharingResponseDtoFromJSON,
    InitiateDataSharingResponseDtoToJSON,
    RequestDetailDtoFromJSON,
    RequestDetailDtoToJSON,
} from '../models/index';

export interface BatchUpdateRequestsRequest {
    batchUpdateRequestsDto: BatchUpdateRequestsDto;
}

export interface GetRequestDetailRequest {
    requestId: string;
}

export interface GetRequestsRequest {
    getDataSharingRequestsDto: GetDataSharingRequestsDto;
}

export interface InitiateDataSharingRequest {
    practiceId: string;
}

/**
 * 
 */
export class PatientDataSharingApi extends runtime.BaseAPI {

    /**
     * Perform batch operations (approve/reject/revoke) on multiple data sharing requests. Returns list of successful and failed operations.
     * Batch update data sharing requests
     */
    async batchUpdateRequestsRaw(requestParameters: BatchUpdateRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BatchOperationResponseDto>> {
        if (requestParameters['batchUpdateRequestsDto'] == null) {
            throw new runtime.RequiredError(
                'batchUpdateRequestsDto',
                'Required parameter "batchUpdateRequestsDto" was null or undefined when calling batchUpdateRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient-data-sharing/requests`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUpdateRequestsDtoToJSON(requestParameters['batchUpdateRequestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchOperationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Perform batch operations (approve/reject/revoke) on multiple data sharing requests. Returns list of successful and failed operations.
     * Batch update data sharing requests
     */
    async batchUpdateRequests(requestParameters: BatchUpdateRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BatchOperationResponseDto> {
        const response = await this.batchUpdateRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a specific data sharing request including practice information, branches, and all timestamps
     * Get data sharing request details
     */
    async getRequestDetailRaw(requestParameters: GetRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RequestDetailDto>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getRequestDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient-data-sharing/requests/{requestId}`.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters['requestId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestDetailDtoFromJSON(jsonValue));
    }

    /**
     * Get detailed information about a specific data sharing request including practice information, branches, and all timestamps
     * Get data sharing request details
     */
    async getRequestDetail(requestParameters: GetRequestDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RequestDetailDto> {
        const response = await this.getRequestDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a consolidated list of data sharing requests with optional filtering by status (pending/live/revoked), search, sort, and pagination capabilities
     * Search data sharing requests
     */
    async getRequestsRaw(requestParameters: GetRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSharingRequestsResponseDto>> {
        if (requestParameters['getDataSharingRequestsDto'] == null) {
            throw new runtime.RequiredError(
                'getDataSharingRequestsDto',
                'Required parameter "getDataSharingRequestsDto" was null or undefined when calling getRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient-data-sharing/requests`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDataSharingRequestsDtoToJSON(requestParameters['getDataSharingRequestsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataSharingRequestsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get a consolidated list of data sharing requests with optional filtering by status (pending/live/revoked), search, sort, and pagination capabilities
     * Search data sharing requests
     */
    async getRequests(requestParameters: GetRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataSharingRequestsResponseDto> {
        const response = await this.getRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patient-initiated: Start sharing health data with a practice immediately. Creates or updates a data sharing request to ACTIVE_SHARING status.
     * Initiate data sharing with a practice
     */
    async initiateDataSharingRaw(requestParameters: InitiateDataSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InitiateDataSharingResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling initiateDataSharing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patient-data-sharing/initiate/{practiceId}`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InitiateDataSharingResponseDtoFromJSON(jsonValue));
    }

    /**
     * Patient-initiated: Start sharing health data with a practice immediately. Creates or updates a data sharing request to ACTIVE_SHARING status.
     * Initiate data sharing with a practice
     */
    async initiateDataSharing(requestParameters: InitiateDataSharingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InitiateDataSharingResponseDto> {
        const response = await this.initiateDataSharingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
